export default {
    namespaced: true,
    state: {
        is_call: false,
        promising_answerer_flag: false
    },
    mutations: {
        // 他機能から呼び出されたかフラグをセット
        setIsCall(state, is_call) {
            state.is_call = is_call;
        },
        // 回答者種別をセット
        setPromisingAnswererFlag(state, promising_answerer_flag) {
            state.promising_answerer_flag = promising_answerer_flag;
        }
    },
    actions: {},
    getters: {
        // 他機能から呼び出されたかフラグを取得
        getIsCall(state) {
            return state.is_call;
        },
        // 回答者種別を取得
        getPromisingAnswererFlag(state) {
            return state.promising_answerer_flag;
        }
    }
};
